/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Group from "vux/src/components/group/index.vue";
import XInput from "vux/src/components/x-input/index.vue";
import FormMobile from '@/components/Base/FormMobile';
export default {
  name: 'ManualInput',
  components: {
    Group: Group,
    XInput: XInput,
    FormMobile: FormMobile
  },
  props: {
    value: Boolean
  },
  data: function data() {
    return {
      rules: {
        product_category_name: {
          required: true,
          message: '产品类型必填'
        },
        product_code: {
          required: true,
          message: '出厂编号必填'
        },
        product_name: {
          required: true,
          message: '设备名称必填'
        }
      },
      form: {}
    };
  },
  methods: {
    sumbit: function sumbit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.validate();

              case 2:
                res = _context.sent;

                if (res) {
                  _this.$emit('updataFun', JSON.parse(JSON.stringify(_this.form)));
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};